import axios from "./axios"; // Import the centralized Axios instance

const state = {
  purchase_order_details: [],
};

const getters = {
  allPurchaseOrderDetails: (state) => state.purchase_order_details,
};

const actions = {
  async fetchPurchaseOrderDetails({ commit }) {
    try {
      commit("resetPurchaseOrderDetails");
      const response = await axios.get("/purchase-order-detail", { params: { page: 1, limit: 25 } });
      commit("setPurchaseOrderDetails", response.data);
    } catch (error) {
      console.error("Failed to fetch purchase_order_details:", error);
    }
  },
  async createPurchaseOrderDetail({ commit }, purchase_order_detail) {
    try {
      const response = await axios.post("/purchase-order-detail", purchase_order_detail);
      commit("addPurchaseOrderDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create purchase_order_detail:", error);
      throw error;
    }
  },
  async fetchPurchaseOrderDetailById(_, id) {
    try {
      const response = await axios.get(`/purchase-order-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch purchase_order_detail:", error);
      throw error;
    }
  },
  async updatePurchaseOrderDetail({ commit }, purchase_order_detail) {
    try {
      const response = await axios.put(`/purchase-order-detail/${purchase_order_detail.id}`, purchase_order_detail);
      commit("updatePurchaseOrderDetail", response.data);
    } catch (error) {
      console.error("Failed to update purchase_order_detail:", error);
      throw error;
    }
  },
  async deletePurchaseOrderDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/purchase-order-detail/${id}`);
      commit("removePurchaseOrderDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete purchase_order_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setPurchaseOrderDetails(state, purchase_order_details) {
    state.purchase_order_details = purchase_order_details.data; // Ensure this matches your API's response structure
  },
  addPurchaseOrderDetail(state, purchase_order_detail) {
    state.purchase_order_details.push(purchase_order_detail);
  },
  updatePurchaseOrderDetail(state, updatedPurchaseOrderDetail) {
    const index = state.purchase_order_details.findIndex(
      (purchase_order_detail) => purchase_order_detail.id === updatedPurchaseOrderDetail.id
    );
    if (index !== -1) {
      state.purchase_order_details.splice(index, 1, updatedPurchaseOrderDetail);
    }
  },
  removePurchaseOrderDetail(state, id) {
    state.purchase_order_details = state.purchase_order_details.filter(
      (purchase_order_detail) => purchase_order_detail.id !== id
    );
  },
  resetPurchaseOrderDetails(state) {
    state.purchase_order_details = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
